<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div :class="{modalContent: true, dragover: dragover, uploading: uploading}"
        v-on:drop.prevent="addFile" v-on:dragover.prevent
        v-on:dragstart="dragStart" v-on:dragenter="dragStart" v-on:dragend="dragEnd"
        v-on:dragexit="dragEnd" v-on:dragleave="dragEnd">
        <div class="close" v-on:click="close(false)"/>
        <div class="uploadingCnt" v-if="uploading">
          <h4>Uploading {{fileUploaded + 1}} of {{imageFiles.length}} files...</h4>
          <div class="uploadPorgress" v-for="(p, i) in progress" :key="i">
            <div class="progress" :id="`progress-${i}`" style="width: 0"></div>
            <div class="percentage" :id="`progress-${i}-label`">0%</div>
          </div>
        </div>
        <div class="modalContentIn" v-if="!uploading">
          <h4>Drop files here to upload</h4>
          <p>Allowed file types: .jpg .png .pdf .mp4 .docx etc</p>
          <br>
          or
          <br>
          <br>
          <button v-on:click="$refs.file.click()">Select File</button>
          <input type="file" ref="file"
            accept="*"
            v-on:change="handleFile" multiple="true"
            style="display: none">
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import HugeUploader from 'huge-uploader';

export default {
  props: ['title', 'desc', 'action'],
  data() {
    return {
      show: false,
      next: null,
      fileUploaded: 0,
      imageFiles: [],
      dragover: false,
      uploading: false,
      uploadPorgress: 0,
      progress: [],
    };
  },
  methods: {
    open(d, next) {
      this.show = true;
      this.fileUploaded = 0;
      this.imageFiles = [];
      this.dragover = false;
      this.uploading = false;
      this.uploadPorgress = 0;
      this.progress = [];
      this.next = next;
    },
    close(b, data) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, data);
    },
    doUpload() {
      this.uploading = true;
      this.fileUploaded = 0;
      this.progress = [];
      this.imageFiles.forEach((file, i) => {
        this.progress[i] = { detail: 0 };
        const uploader = new HugeUploader({
          endpoint: this.$config.uri('media/upload'),
          chunkSize: 1,
          file,
          headers: {
            Key: this.$config.apiKey,
            Authoziration: this.$session.get(`${this.$config.appId}_jwt`),
            Filename: file.name,
            Filetype: file.type,
          },
        });
        uploader.on('error', (err) => {
          // console.error('Something bad happened', err.detail);
        });
        uploader.on('progress', (progress) => {
          // this.uploadPorgress = Math.floor(progress.detail);
          // this.progress[i].detail = Math.floor(progress.detail);
          const progVal = Math.floor(progress.detail);
          document.getElementById(`progress-${i}`).style.width = `${progVal}%`;
          document.getElementById(`progress-${i}-label`).innerHTML = `${progVal}%`;
        });
        uploader.on('finish', (body) => {
          this.fileUploaded += 1;
          if (this.fileUploaded === this.imageFiles.length) {
            // Upload finished...
            this.close(true);
          }
        });
        // if you want to pause/resume the upload
        // uploader.togglePause();
      });
    },
    handleFile() {
      if (this.uploading) return;
      this.imageFiles = this.$refs.file.files;
      this.doUpload();
    },
    addFile(e) {
      this.dragover = false;
      if (this.uploading) return;
      const droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      ([...droppedFiles]).forEach((f) => {
        this.imageFiles.push(f);
      });
      this.doUpload();
    },
    dragStart() {
      this.dragover = true;
    },
    dragEnd() {
      this.dragover = false;
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 9;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    // background-color: rgba(255,255,255,.8);
    // backdrop-filter: saturate(180%) blur(20px);
    .modalContent{
      position: absolute;
      left: 20px; top: 20px; right: 20px; bottom: 20px;
      border: #ccc 4px dashed;
      border-radius: 0;
      text-align: center;
      max-width: none;
      margin: 0;
      overflow: visible;
      &.dragover{
        border-color: #0057d8;
      }
      &.uploading{
        border-color: transparent;
        .uploadingCnt{
          position: absolute;
          left: 50%; top: 50%;
          color: #444;
          transform: translate(-50%, -50%);
          width: 420px;
          max-height: 80vh;
          overflow-y: auto;
          padding-right: 64px;
          .uploadPorgress{
            height: 10px;
            background-color: #ddd;
            border-radius: 50px;
            margin-top: 14px;
            position: relative;
            .progress{
              background-color: #0f5cd2;
              height: 100%;
              border-radius: 50px;
              transition: all .3s ease;
            }
            .percentage{
              position: absolute;
              right: -44px;
              top: -5px;
              font-size: 14px;
              color: #767676;
            }
            span{
              display: none;
            }
          }
          h4{
            margin: 0 0 24px;
            font-size: 24px;
          }
          p{
            color: #767676;
            font-size: 13px;
          }
        }
      }
      .close{
        position: absolute;
        right: -15px; top: -15px;
        background-color: #fff;
        border-radius: 50%;
        width: 40px; height: 40px;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        &:hover{
          background-color: #eee;
        }
      }
      .modalContentIn{
        text-align: center;
        position: absolute;
        left: 50%; top: 50%;
        transform: translate(-50%, -50%);
        color: #767676;
        h4{
          margin: 0;
          font-size: 24px;
          font-weight: normal;
          margin-bottom: 5px;
          color: #444;
        }
        p{
          margin: 0;
          color: #767676;
        }
        button{
          border-radius: 3px;
          color: #fff;
          border: none;
          box-shadow: none;
          font-size: 18px;
          background-color: #0057d8;
          padding: 10px 20px;
          outline: 0;
          cursor: pointer;
          &:hover{
            background-color: #0067ff;
          }
        }
      }
    }
  }
</style>
